import React from 'react';
import { CampaignContainerStyled } from './styled';
import { withRouter } from 'navigations/withRouter';
import { ROUTE_PATH } from 'utils/constants/routePath';
import { scrollToTopPageFN } from 'utils/functions/scrollTopPage';
import { portalService } from 'apiServices';
import moment from 'moment';
import 'moment-timezone';
import { MdAdd } from 'react-icons/md';
import { RENDER_PUBLISH } from 'utils/functions/campaign';
import { Buttons, Inputs, Displays, Tables } from 'components';
import {
  parseFilterQuery,
  syncFilterUrlQuery,
} from 'utils/functions/filterQuery';

const FILTER_FIELDS = ['name'];

class CampaignContainer extends React.Component {
  state = {
    isLoading: true,
    pagination: null,
    perPage: 10,
    // เปลี่ยน key เพื่อบังคับสร้าง InputFilter ใหม่ตอนกดล้างค่า
    filterKey: 0,
    ...parseFilterQuery(this.props.router.location.search, FILTER_FIELDS),
  };

  componentDidMount() {
    const { filterQuery, currentPage } = this.state;
    scrollToTopPageFN();
    this.handleJoinQuery(filterQuery, currentPage);
  }

  fetchData = async (stringQuery) => {
    let res = await portalService.GET_CAMPAIGN_LIST(stringQuery);
    if (res && res.status === 200) {
      this.setState({
        data: res.data.docs,
        isLoading: false,
        pagination: {
          last_page: res.data.totalPages,
          current_page: res.data.page,
        },
      });
    } else {
      this.setState({ isLoading: false });
    }
  };

  handleFilterKeyword = (e) => {
    const parsedQuery = parseFilterQuery(e, FILTER_FIELDS);
    this.setState({ ...parsedQuery });
    this.handleJoinQuery(parsedQuery.filterQuery, 1);
  };

  handleClearFilter = () => {
    this.setState((prevState) => ({
      ...parseFilterQuery('', FILTER_FIELDS),
      filterKey: prevState.filterKey + 1,
    }));
    this.handleJoinQuery('', 1);
  };

  handleClickCreate = (e) => {
    this.props.router.navigate(`${ROUTE_PATH.CAMPAIGN_DATA}/${e}`);
  };

  handlePageClick = (e) => {
    const { filterQuery } = this.state;
    this.handleJoinQuery(filterQuery, e.selected + 1);
  };

  handleJoinQuery = (query, page) => {
    const { perPage } = this.state;
    let joinQuery = query
      ? `${query}&limit=${perPage}&page=${page}`
      : `?limit=${perPage}&page=${page}`;
    this.setState({
      isLoading: true,
      currentPage: page,
    });
    syncFilterUrlQuery(this.props.router, query, page);
    this.fetchData(joinQuery);
  };

  render() {
    const { isLoading, pagination, data, filterValues, filterKey } =
      this.state;
    return (
      <CampaignContainerStyled>
        <div className="btn_create">
          <div className="w120">
            <Buttons.BgIconPrefix
              label="New"
              icon={<MdAdd size={18} />}
              onClick={() => this.handleClickCreate('create')}
            />
          </div>
        </div>
        <Inputs.InputFilter
          key={filterKey}
          theme_standard_input_filter
          dataFilter={dataFilter(filterValues)}
          btnLabel="ค้นหา"
          clearLabel="ล้างค่า"
          onQueryFilter={this.handleFilterKeyword}
          onClear={this.handleClearFilter}
        />
        {isLoading ? (
          <Displays.Loading theme_standard_loading heightLayout="324px" />
        ) : (
          <>
            <div className="body_table  ">
              <Tables.Standard
                columns={columns({ handleClickDetail: this.handleClickCreate })}
                data={data}
                showPagination
                pagination={pagination}
                handlePageClick={this.handlePageClick}
              />
            </div>
          </>
        )}
      </CampaignContainerStyled>
    );
  }
}

const dataFilter = (filterValues) => [
  {
    accessor: 'name',
    length: '311px',
    filter: {
      fieldQuery: 'name',
      type: 'text',
      defaultValue: filterValues.name,
      label: 'Campaign search',
      placeholder: 'Campaign code/Campaign name',
    },
  },
];

const columns = ({ handleClickDetail }) => [
  {
    Header: <div style={{ textAlign: 'left' }}>Publication Date</div>,
    accessor: 'created_at',
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {moment(props.value).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm')}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'left' }}>Campaign Code</div>,
    accessor: 'code',
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {props.value}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'left' }}>Campaign Name</div>,
    accessor: 'name',
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {props.value}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'left' }}>Publish</div>,
    accessor: 'publish_type',
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {RENDER_PUBLISH(props.value)}
      </div>
    ),
  },
  {
    Header: 'status',
    accessor: 'is_active',
    Cell: (props) => (
      <div
        className="body_status"
        onClick={() => handleClickDetail(props.row.original._id)}
      >
        <div
          className="round"
          style={{ background: props.value === true ? 'green' : 'red' }}
        />
      </div>
    ),
  },
];

export default withRouter(CampaignContainer);
